import { FontsEnum } from 'core/constants/enums/FontsEnum.ts';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { reusableStyles } from '../../../ui-blocks/ReusableStyles';

export const inputComponentsStyles = {
	settingsSliceWrapper: {
		flexShrink: 0,
		width: '100%',
	},
	settingsSlice: {
		display: 'flex',
		flexDirection: 'column',
	},

	settingsSliceLabelWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	settingsSliceLabelTextCont: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingsSliceLabel: { color: 'colors.light3' },
	settingsSliceDesc: { marginTop: '4px', color: 'colors.light4' },

	textAreaInputWrapper: {
		width: '100%',
		padding: '12px',
		borderRadius: '4px',

		display: 'flex',
		flexDirection: 'column',

		textAlign: 'left',
	},
	textAreaInput: {
		padding: 0,
		margin: 0,

		color: 'colors.light2',

		fontFamily: FontsEnum.INTER,
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 400,
		letterSpacing: '0.1px',
	},
	canvasTextAreaInput: {
		'& .MuiInputBase-input': {
			color: 'colors.light5',
			fontFamily: 'Inter',
			fontSize: '12px',
			lineHeight: '24px',
			fontWeight: 400,
			letterSpacing: '0.1px',
		},
	},
	textFieldInputWrapper: {
		width: '100%',
		padding: '8px 13px',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.dark1}`,
		marginTop: '12px',

		display: 'flex',
		flexDirection: 'column',

		textAlign: 'left',
	},
	textFieldInput: {
		'& .MuiInputBase-root': {
			height: '24px',
			padding: 0,

			fontFamily: FontsEnum.INTER,
			fontSize: '12px',
			lineHeight: '16px',
			fontWeight: 400,
			letterSpacing: '0.1px',
		},
		input: {
			color: colorPalette.light2,

			'&.Mui-disabled': {
				color: colorPalette.light5,
				WebkitTextFillColor: colorPalette.light5,
			},
		},
	},

	sliderInputWrapper: {
		marginTop: '8px',
		padding: '0 10px',
	},
	slider: {
		'&.MuiSlider-root': {
			padding: '6px 0',
			height: '8px',
			width: 'calc(100% - 12px)',
			margin: 0,
			borderRadius: '15px',
			color: colorPalette.rainbowBlue,

			'& .MuiSlider-rail': {
				backgroundColor: colorPalette.dark0,
			},
			'& .MuiSlider-track': {
				border: 'none',
				borderRadius: '15px',
			},
			'& .MuiSlider-thumb': {
				height: '20px',
				width: '20px',
				backgroundColor: colorPalette.blue3,
				boxShadow: '1px 0px 4px rgba(0, 0, 0, 0.45)',
			},
		},
	},

	studioSlider: {
		'&.MuiSlider-root': {
			width: { xs: '125px', sm: '185px' },
			borderRadius: '15px',
			color: colorPalette.rainbowBlue,

			'& .MuiSlider-rail': {
				backgroundColor: colorPalette.dark1,
			},
			'& .MuiSlider-track': {
				border: 'none',
				borderRadius: '15px',
			},
			'& .MuiSlider-thumb': {
				boxShadow: 'none',
				height: '12px',
				width: '12px',
				backgroundColor: 'colors.black',
				borderRadius: '15px',
				borderColor: 'colors.blue3',
				borderStyle: 'solid',
				borderWidth: '2px',
			},
		},
	},
	canvasSlider: {
		'&.MuiSlider-root': {
			padding: '6px 0',
			height: '4px',
			width: 'calc(100% - 12px)',
			margin: 0,
			borderRadius: '15px',
			color: colorPalette.rainbowBlue,

			'& .MuiSlider-rail': {
				backgroundColor: colorPalette.dark1,
			},
			'& .MuiSlider-track': {
				border: 'none',
				borderRadius: '15px',
			},
			'& .MuiSlider-thumb': {
				height: '15px',
				width: '15px',
				backgroundColor: 'colors.dark1',
				borderRadius: '15px',
				borderColor: 'colors.blue3',
				borderStyle: 'solid',
				borderWidth: '2px',
			},
		},
	},
	sliderOutputWrapper: {
		width: '70px',
		padding: '8px',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.dark1}`,

		backgroundColor: 'colors.dark3',

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},

	select: {
		height: '40px',
		width: '100%',
		padding: '8px 13px',
		border: `1px solid ${colorPalette.dark1}`,
		borderRadius: '4px',

		backgroundColor: 'colors.dark3',
		color: 'colors.light2',

		fontSize: '14px',
		fontWeight: 500,

		'&::before': {
			border: 'none !important',
		},
		'&::after': {
			border: 'none !important',
		},
		'&::hover': {
			border: 'none !important',
		},

		'& .MuiInputBase-root': { fontSize: '14px' },
		'& .MuiSelect-icon': {
			color: colorPalette.light3,
			fontSize: '24px',
		},
	},
	menuItem: {
		padding: '16px',

		color: 'colors.light2',

		display: 'flex',
		justifyContent: 'space-between',

		'&:first-of-type': { paddingTop: '8px' },
		'&:last-of-type': { paddingBottom: '8px' },
		'&:not(:last-of-type)': {
			borderBottom: `1px solid ${colorPalette.dark2}`,
		},
		'&:hover': { backgroundColor: 'transparent' },
		'&.Mui-selected': { backgroundColor: 'transparent' },
		'&.Mui-selected:hover': { backgroundColor: 'transparent' },
	},

	selectPopover: {
		button: {
			height: '40px',
			width: '100%',
			padding: '8.5px 12.5px',
			border: `1px solid ${colorPalette.dark1}`,
			marginTop: '16px',

			backgroundColor: 'colors.dark2',

			textTransform: ' none',

			display: 'flex',
			justifyContent: 'space-between',

			'&:hover': {
				backgroundColor: 'colors.dark2',
			},
		},
		popover: {
			width: '322px',

			backgroundColor: colorPalette.dark4,

			display: 'flex',
			flexDirection: 'column',
		},
		menuItem: {
			padding: '24px 16px',

			color: 'colors.light2',

			display: 'flex',
			justifyContent: 'space-between',

			cursor: 'pointer',

			'&:not(:last-of-type)': {
				borderBottom: `1px solid ${colorPalette.dark2}`,
			},
			'&:hover': { backgroundColor: 'transparent' },
			'&.Mui-selected': { backgroundColor: 'transparent' },
			'&.Mui-selected:hover': { backgroundColor: 'transparent' },
		},
	},

	chipsInputComp: {
		width: '100%',
		marginTop: '16px',

		display: 'flex',
		flexWrap: 'wrap',
		gap: '16px',
	},
	chip: {
		minWidth: '72px',
		padding: '4px',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderRadius: '4px',

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '4px',

		cursor: 'pointer',

		'& svg': { height: '14px', width: 'auto' },
	},
	controlNetSlice: {
		display: 'flex',
		flexDirection: 'column',
	},
	controlNetSliceLabelWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	controlNetSliceLabelTextCont: {
		width: '100%',

		display: 'flex',
		flexDirection: 'column',
	},
	controlNetSliceLabel: {
		color: 'colors.light3',
	},
	controlNetSliceDesc: {
		marginTop: '4px',
		color: 'colors.light4',
	},
	facelockSlice: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	facelockSliceLabelWrapper: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	facelockSliceLabelTextCont: {
		width: '100%',
		...reusableStyles.flexColWithGap(12),
		paddingX: '25px',
		paddingBottom: '16px',
		paddingTop: '8px',
		backgroundColor: 'colors.dark6',
		borderRadius: '4px',
	},
	canvasPopover: {
		height: '40px',
		width: '100%',
		padding: '8.5px 12.5px',
		border: `1px solid ${colorPalette.dark3}`,
		marginTop: '16px',

		backgroundColor: 'colors.dark4',

		textTransform: ' none',

		display: 'flex',
		justifyContent: 'space-between',

		'&:hover': {
			backgroundColor: 'colors.dark2',
		},
	},
	canvasInputContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '10px',
	},
	canvasTextInputContainer: {
		width: '40px',
		padding: '8px 12px 8px 12px',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.dark3}`,
		backgroundColor: 'colors.dark6',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	baseLabelledRadio: {
		margin: 0,
	},
};
